import moment from 'moment';

import { isNumberInRange, isNumberInRangeSoft } from '../helpers';
import { datePickerConstants } from '../constants';

import dateValidation from './dateValidation';

const flagsMapping = {
    UNIX_LINES: '',
    CASE_INSENSITIVE: 'i',
    COMMENTS: 'x',
    MULTILINE: 'm',
    DOTALL: 's',
    UNICODE_CASE: 'u',
    CANON_EQ: '',
};

export const equalsTo = (currValue, data, params) => {
    const isCaseInsensitive = !!params.flags && params.flags.includes('CASE_INSENSITIVE');
    const dataValue = data[params.fieldCompare].value;

    if (!!currValue && isCaseInsensitive && dataValue) {
        return currValue.toLowerCase() === dataValue.toLowerCase();
    }
    return !!currValue && currValue === dataValue;
};

export const required = (value, _0, _1, _2, trimValue) =>
    value === undefined || (typeof value === 'string' && trimValue ? !!value.trim() : !!value);

export const pattern = (fieldValue, _, params, valueCompare) => {
    const flagsList = params.flags || [];
    const valuesCompare = (params.valuesCompare && params.valuesCompare.entry) || [];

    const flags = flagsList
        .filter(flagKey => flagsList.includes(flagKey))
        .map(flagKey => flagsMapping[flagKey])
        .join();

    let { regex } = params;
    const newReg = valuesCompare.find((objCompare = {}) => objCompare.key === valueCompare);
    regex = newReg ? newReg.value : regex;
    const { XRegExp } = window.e2_assets;

    // avoid js explosions due to wrong smartEdit configurations
    try {
        return !fieldValue || XRegExp(regex, flags).test(fieldValue);
    } catch (err) {
        try {
            return XRegExp(regex).test(fieldValue);
        } catch (err) {
            return true;
        }
    }
};

export const length = (fieldValue, _, params) =>
    !fieldValue || (params && fieldValue.length >= params.min && fieldValue.length <= params.max);

export const ageVerified = (fieldValue, _, params, softComparison = false) => {
    const minAge = (params && params.min) || 0;
    const maxAge = (params && params.max) || 120;
    const birthDate = moment(fieldValue, datePickerConstants.DEFAULT_FORMAT);
    const age = moment().diff(birthDate, 'years');
    return softComparison
        ? isNumberInRangeSoft(age, minAge, maxAge)
        : isNumberInRange(age, minAge, maxAge);
};

export const isValidField = fieldValue => {
    return fieldValue.value && !fieldValue.error;
};

export const isNotEmptyField = fieldValue => {
    return fieldValue.value;
};

export const max = (fieldValue, _, params) => !fieldValue || fieldValue <= params.max;

export const min = (fieldValue, _, params) => !fieldValue || fieldValue >= params.min;

export default {
    ageVerified,
    equalsTo,
    required,
    pattern,
    length,
    isValidField,
    isNotEmptyField,
    min,
    max,
    ...dateValidation,
};
